export const STAKEHOLDER_TEMPLATE = [
  { name: "", role: "Sponsor / Champion", influence: "high", interest: "high" },
  { name: "", role: "Process Owner", influence: "high", interest: "high" },
  { name: "", role: "Quality Lead", influence: "medium", interest: "high" },
  { name: "", role: "Project Lead / Black Belt", influence: "high", interest: "high" },
  { name: "", role: "Frontline Operators", influence: "medium", interest: "high" },
  { name: "", role: "Maintenance", influence: "medium", interest: "medium" },
  { name: "", role: "Engineering", influence: "medium", interest: "medium" },
  { name: "", role: "Supply Chain", influence: "medium", interest: "medium" },
  { name: "", role: "Voice of Customer", influence: "medium", interest: "high" },
];

export function createBlankStakeholder() {
  return { name: "", role: "", influence: "medium", interest: "medium" };
}

export function normalizeStakeholderDraft(stakeholders = []) {
  if (!stakeholders.length) {
    return [createBlankStakeholder()];
  }

  return stakeholders.map((stakeholder) => ({
    name: stakeholder.name || "",
    role: stakeholder.role || "",
    influence: stakeholder.influence || "medium",
    interest: stakeholder.interest || "medium",
  }));
}
